<template>
	<div class="large-deposit-container">
		<div class="deposit-header" v-if="bannerImage">
			<img style="width: 100%;" :src="bannerImage" alt="">
		</div>
		<!-- 银行账户信息 -->
		<div class="bank-info-section">
			<!-- 港币储值账号 -->
			<div class="bank-account hk-account">
				<div class="account-header">
					<h3>
						<i class="icon-tw"></i>
						台幣儲值帳號
					</h3>
				</div>
				<div v-if="gameCode == 'cztxtw'" class="account-details">
					<div class="detail-row">
						<span class="label">銀行：</span>
						<span class="value">國泰世華銀行(世貿分行)</span>
					</div>
					<div class="detail-row">
						<span class="label">戶名(代理金流商)：</span>
						<span class="value">贊佳數位行销有限公司</span>
					</div>
					<div class="detail-row">
						<span class="label">銀行代碼：</span>
						<span class="value">013</span>
					</div>
					<div class="detail-row">
						<span class="label">銀行帳戶：</span>
						<span class="value">065-03-5014947</span>
					</div>
					<div class="warning-text">
						<strong>*注意：</strong>該帳號只支持台湾帳戶玩家使用,只支持「台幣」轉帳，詳情請詢問客服
					</div>
				</div>
				<div v-if="gameCode == 'sgyjltw'" class="account-details">
					<div class="detail-row">
						<span class="label">銀行：</span>
						<span class="value">國泰世華銀行(南門分行)</span>
					</div>
					<div class="detail-row">
						<span class="label">戶名(代理金流商)：</span>
						<span class="value">荷馬娛樂股份有限公司</span>
					</div>
					<div class="detail-row">
						<span class="label">銀行代碼：</span>
						<span class="value">013</span>
					</div>
					<div class="detail-row">
						<span class="label">銀行帳戶：</span>
						<span class="value">076-03-501098-6</span>
					</div>
					<div class="detail-row">
						<span class="label">銀行地址：</span>
						<span class="value">台北市羅斯福路二段5號</span>
					</div>
					<div class="detail-row">
						<span class="label">銀行電話：</span>
						<span class="value">(02)2322 2777</span>
					</div>
					<div class="warning-text">
						<strong>*注意：</strong>該帳號只支持台湾帳戶玩家使用,只支持「台幣」轉帳，詳情請詢問客服
					</div>
				</div>
			</div>

			<!-- 台币储值账号 -->
			<div class="bank-account tw-account">
				<div class="account-header">
					<h3>
						<i class="icon-hk"></i>
						港幣儲值帳號
					</h3>
				</div>
				<div class="account-details">
					<div class="detail-row">
						<span class="label">銀行：</span>
						<span class="value">Bank of China (Hong Kong) Limited, HongKong</span>
					</div>
					<div class="detail-row">
						<span class="label">戶名(代理金流商)：</span>
						<span class="value">MIAOPLAY ENTERTAINMENT NETWORK LIMITED</span>
					</div>
					<div class="detail-row">
						<span class="label">銀行帳號：</span>
						<span class="value">012</span>
					</div>
					<div class="detail-row">
						<span class="label">SWIFT CODE：</span>
						<span class="value">BKCHKHKHHXXX</span>
					</div>
					<div class="detail-row">
						<span class="label">匯款(轉帳)帳號：</span>
						<span class="value">012-687-2-033788-7</span>
					</div>
					<div class="detail-row">
						<span class="label">收款銀行地址：</span>
						<span class="value">BANK OF CHINA TOWER 1GARDEN ROAD,CENTRAL,HONGKONG</span>
					</div>
					<div class="warning-text">
						<strong>*注意：</strong>該帳號只支持香港帳戶玩家使用·只支持「港幣」轉帳·詳情請詢問客服
					</div>
				</div>
			</div>
		</div>
		<div class="form-toggle">
			<button @click="showForm = !showForm" class="toggle-btn">
				<i class="icon-form"></i>
				{{ showForm ? '隱藏匯款表單' : '顯示匯款表單' }}
			</button>
		</div>
		<BankRemitForm ref="bankRemitForm" @success="handleSuccess" v-if="showForm"></BankRemitForm>
		<BankRemitData ref="bankRemitData"></BankRemitData>
	</div>
</template>

<script>
import BankRemitForm from '../components/BankRemitForm.vue'
import BankRemitData from '../components/BankRemitData.vue'

const BANNER_MAP = {
	sgyjltw: 'https://cdn-download.luckyyx.com/image/cms/20260601/7078a5c4297043298ef46a6e8e932d20.jpg',
	cztxtw: 'https://cdn-download.dustyx.com/image/cms/20250822/5c4168c845574499a376f65be356fbbb.png',
}

export default {
	name: 'BankRemit',
	components: {
		BankRemitForm,
		BankRemitData
	},
	computed: {
		bannerImage() {
			const gameCode = this.$cache.getGameCode();
			return BANNER_MAP[gameCode] || '';
		}
	},
	data() {
		return {
			showForm: true,
			gameCode: this.$cache.getGameCode()
		}
	},
	methods: {
		handleSuccess(state) {
			this.showForm = state;
			this.$refs.bankRemitData.loadBankRemitInfo();
		},
	}
}
</script>

<style scoped>
.deposit-header {
	all: initial;
	display: block;
	margin-bottom: 20px;
}

.large-deposit-container {
	max-width: 1200px;
	margin: 20px auto;
}

.bank-info-section {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
	margin-top: 30px;
}

.bank-account {
	background: white;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
	border: 1px solid #f0f0f0;
	display: flex;
	flex-direction: column;
}

.account-header {
	padding: 12px;
	text-align: center;
}

.account-header h3 {
	margin: 0;
	font-size: 17px;
	font-weight: bold;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
}

.icon-hk {
	display: inline-block;
	width: 20px;
	height: 20px;
	margin-right: 8px;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M12 2L2 7v10l10 5 10-5V7L12 2zm0 2.5L19.5 8 12 11.5 4.5 8 12 4.5z'/%3E%3C/svg%3E");
	background-size: contain;
}

.icon-tw {
	display: inline-block;
	width: 20px;
	height: 20px;
	margin-right: 8px;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'/%3E%3C/svg%3E");
	background-size: contain;
}

.hk-account .account-header {
	background: #03d2ff;
}

.tw-account .account-header {
	background: #f31f1c;
}

.tw-account .icon-hk {
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z'/%3E%3C/svg%3E");
}

.account-details {
	padding: 16px;
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	/* 填充剩余空间 */
}

.detail-row {
	display: flex;
	margin-bottom: 12px;
	align-items: center;
}

.detail-row .label {
	width: 140px;
	font-weight: 500;
	color: #666;
	font-size: 14px;
}

.detail-row .value {
	color: #333;
	font-size: 14px;
	flex: 1;
}

.warning-text {
	background: #f8f9fa;
	border: 1px solid #e9ecef;
	border-radius: 4px;
	padding: 12px;
	margin-top: auto;
	font-size: 13px;
	color: #e65100;
}

.toggle-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 12px 30px;
	margin: 20px auto;
	width: 100%;
	background: white;
	border: 2px dashed #03d2ff;
	border-radius: 8px;
	color: #03d2ff;
	font-weight: bold;
	cursor: pointer;
	transition: all 0.3s ease;
	font-size: 15px;
}

.toggle-btn:hover {
	background: #f0f9ff;
	border-color: #03d2ff;
}

.icon-form {
	display: inline-block;
	width: 20px;
	height: 20px;
	margin-right: 8px;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2303d2ff'%3E%3Cpath d='M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 12h10v2H7zm0-4h10v2H7z'/%3E%3C/svg%3E");
	background-size: contain;
}

@media (max-width: 768px) {
	.bank-info-section {
		grid-template-columns: 1fr;
		gap: 15px;
	}

	.bank-account {
		margin-bottom: 15px;
	}

	.account-header {
		padding: 12px;
	}

	.account-header h3 {
		font-size: 16px;
	}

	.account-details {
		padding: 15px;
	}

	.detail-row {
		flex-direction: column;
		align-items: flex-start;
		margin-bottom: 10px;
	}

	.detail-row .label {
		width: 100%;
		margin-bottom: 5px;
		font-size: 13px;
	}

	.detail-row .value {
		font-size: 13px;
		width: 100%;
	}

	.warning-text {
		font-size: 12px;
		padding: 10px;
	}

	.toggle-btn {
		padding: 10px 20px;
		font-size: 14px;
		max-width: 250px;
	}
}
</style>